import { createSlice } from '@reduxjs/toolkit';
import {
  loadTranslationsFile,
  toggleLanguage,
} from './languageThunk'
import CookiesStorageService from '../../../services/CookiesStorageService';

const initialState = {
  language: CookiesStorageService.getUserLanguage() || 'EN',
  translations: {},
}

const languageSlice = createSlice({
  name: 'language',
  initialState,
  extraReducers: {
    [loadTranslationsFile.fulfilled]: (state, { payload }) => {
      state.translations = payload
      state.language = CookiesStorageService.getUserLanguage() || state.language
      document.documentElement.dir = state.language === 'AR' ? 'rtl' : 'ltr'
      document.documentElement.lang = state.language === 'AR' ? 'ar' : 'en'
    },

    [toggleLanguage.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },

    [toggleLanguage.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },

    [toggleLanguage.fulfilled]: (state) => {
      state.loading = false
      state.alert = {}
    },

  },
})

export const selectLanguage = (state) => state.language

export default languageSlice.reducer
